<template>
    <img src=  "../../assets/images/1490.gif" alt="Page loading"/>
  </template>
  
  <script>
  export default {
    name: "LoadingGif",
  };
  </script>
  <style scoped>
img{
  max-width:55px;
  height:55px;
}
</style>